@if (_orderItem && product && _order && initialized) {
  <div class="product-order-item" [ngClass]="viewType">
    <ng-container
      *ngTemplateOutlet="
        modal
          ? modalView
          : readonly && mobileDevice
            ? mobileReadOnlyView
            : desktopView
      "
    >
    </ng-container>
  </div>
}

<ng-template #desktopView>
  <div class="product-order-item__row">
    @if (product.media && viewType === 'list-item') {
      <div class="image">
        <img [src]="product.media | thumbnail" [alt]="product.label" />
      </div>
    }

    <div>
      <!--header-->
      <app-product-order-item-header
        [orderItem]="_orderItem"
        [order]="_order"
        [viewType]="viewType"
        [showHideItemButton]="showHideItemButton"
        [showReorderButton]="showReorderButton"
        [readonly]="readonly"
        [modal]="modal"
        (changedVisibility)="onOrderItemChangeVisibility($event)"
        (editted)="onUpdate.emit()"
        (reorderItem)="reorderItem()"
      ></app-product-order-item-header>

      <ng-container
        *ngTemplateOutlet="mobileDevice ? placeOrderMobileView : placeOrderView"
      ></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #modalView>
  <div class="modal-container">
    <div class="product--container">
      <div class="product-details--mobile">
        <ng-container *ngTemplateOutlet="productDetailsView"></ng-container>
      </div>

      <div class="product-gallery bottom_line">
        <div class="product-gallery--box">
          <product-gallery
            [product]="product"
            [modalView]="true"
          ></product-gallery>
        </div>
      </div>
      <div
        class="product-description py-3 bottom_line"
        [innerHTML]="product.content.description | truncate: 300 | safeContent"
      ></div>
    </div>
    <div class="order-item--container">
      <div class="product-details--desktop">
        <ng-container *ngTemplateOutlet="productDetailsView"></ng-container>
      </div>

      <div>
        <ng-container *ngTemplateOutlet="placeOrderView"></ng-container>
      </div>
    </div>
  </div>
  @if (!readonly) {
    <a
      class="d-block link link-underline small text-align-center my-3"
      (click)="redirectToFullProduct()"
      >View Full Item Details</a
    >
  }
</ng-template>

<ng-template #productDetailsView>
  <div class="bottom_line pb-2 px-3">
    <h1
      class="product-label my-0"
      [innerHTML]="product.label | safeContent"
    ></h1>
    <p class="mb-2">SKU: {{ product.skus[0].getDisplaySkuID() }}</p>
    <app-product-flag-container
      [product]="product"
    ></app-product-flag-container>
    <div class="d-block">
      @for (type of product.sustainability; track $index) {
        <app-product-sustainable-item
          [sustainableType]="type"
          [showBorder]="true"
        ></app-product-sustainable-item>
      }
    </div>
    <div class="product-meta">
      <div>
        @if (isProductRecommended) {
          <app-product-recommened-quantity
            [recommendedQty]="product.recommended_qty_expected"
            [currentQty]="product.recommended_qty_current"
          ></app-product-recommened-quantity>
        }
        @if (
          !this.readonly && !product.hasVariations && !product.isBuyingWindow
        ) {
          <div class="availability--container">
            <app-product-order-item-in-stock
              [product]="product"
              [quantity]="_orderItem.quantity"
              [orderItemId]="_orderItem.id"
              [viewType]="viewType"
              fontSize="font-4"
              class="availability--container"
            ></app-product-order-item-in-stock>
          </div>
        }

        @if (showMinOrderInHeader) {
          <app-product-order-item-min-max
            [shouldShowAvailableQuantity]="!product.hasVariations"
            [isRecommended]="isProductRecommended"
            [headerPosition]="true"
            [orderItem]="_orderItem"
            [viewType]="viewType"
            fontSize="font-4"
          >
          </app-product-order-item-min-max>
        }

        @if (product.isCustomizable) {
          <div class="d-flex">
            <span>Custom Min Required:</span>
            <span class="fw-bold ms-2">{{
              product.customization.custom_min_qty
            }}</span>
          </div>
        }
      </div>
      <div class="price--container pe-3">
        @if (!product.hasVariations && !discontinued) {
          <app-product-order-item-price
            [orderItem]="_orderItem"
            [ngClass]="'list-item'"
            [modal]="modal"
            fontSize="font-3"
          >
          </app-product-order-item-price>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #placeOrderView>
  @if (
    !readonly &&
    !discontinued &&
    isDecisionPointOrder &&
    !product.hasVariations &&
    (product.window_id > 0 ||
      !product.inventoryType ||
      product.inStock ||
      _orderItem.deliveries.length > 0)
  ) {
    <div class="order-item__decision-point bottom_line mt-3">
      @if (dpSummaryData) {
        <div class="d-flex flex-column align-items-center">
          <button
            (click)="showDpModal()"
            type="button"
            class="btn btn-outline-primary"
            [disabled]="!canShowDPModal"
          >
            <span>Update Decision Point Quantity</span>
          </button>
          <p class="text-center mt-2 color--primary-grey font-4">
            {{ dpSummaryData.eligible_wslr_count }} Wholesalers and
            {{ dpSummaryData.store_count }} Stores&nbsp;<button
              class="btn btn-icon"
              (click)="showDPFaqDialog()"
            >
              <i class="fas fa-exclamation-circle"></i>
            </button>
          </p>
        </div>
      }
      @if (loadingSummaryData) {
        <div>
          <app-infinite-progress [inProgress]="true"></app-infinite-progress>
        </div>
      }
    </div>
  }

  @if (
    !readonly && !discontinued && isDecisionPointOrder && product.hasVariations
  ) {
    <div class="order-item__decision-point bottom_line">
      <p class="mt-3 color-red">
        Currently you cannot order by Decision Point for items with sizes or
        variations. Thank you for your patience.
      </p>
    </div>
  }

  @if (product.hasVariations && canOrder && !showVariations) {
    <div class="pb-3">
      <button
        class="btn btn-primary float-end"
        (click)="redirectToFullProduct()"
        type="button"
        name="update"
      >
        Product Detail
      </button>
      <p class="variation-message">
        This product has variations. Please use the product detail to order this
        item
      </p>
    </div>
  }

  @if (discontinued) {
    <div class="mt-4rem">
      <ng-container *ngTemplateOutlet="productDiscontinued"> </ng-container>
    </div>
  }

  @if ((!discontinued && !product.hasVariations) || showVariations) {
    <div class="mt-2">
      <!--    delivery items-->
      @if (delivery && _orderItem.hidden === false) {
        <app-product-order-item-delivery
          [delivery]="delivery"
          [product]="product"
          [viewType]="viewType"
          [order]="_order"
          [orderItem]="_orderItem"
          [readonly]="readonly"
          [showEditControls]="showEditControls"
          [totals]="totalCost"
          [showTotalInline]="!showTotals"
          [isFirstShipment]="true"
          [isLastShipment]="true"
          [showTrackingInfo]="showTrackingInfo"
          [canRemoveAddress]="!isDecisionPointOrder"
          [paidQuantity]="paidQuantity"
          (customizationChanged)="onCustomizationChanged()"
          (deliverToChanged)="onDeliveryChanged()"
          (changed)="onOrderItemChanged($event)"
          [refreshingTrackingStatus]="refreshingTrackingStatus"
          (refreshStatus)="refreshTrackingStatus()"
        >
        </app-product-order-item-delivery>
      }
      @if (!discontinued && !delivery && _orderItem.hidden === false) {
        @for (
          delivery of getActualDeliveries();
          track trackByDeliveryUuid(i, delivery);
          let i = $index
        ) {
          <app-product-order-item-delivery
            [delivery]="delivery"
            [product]="product"
            [viewType]="viewType"
            [order]="_order"
            [orderItem]="_orderItem"
            [readonly]="readonly"
            [showEditControls]="showEditControls"
            [totals]="totalCost"
            [showTotalInline]="!showTotals"
            [showTrackingInfo]="showTrackingInfo"
            [isFirstShipment]="i === 0"
            [isLastShipment]="getActualDeliveries().length == i + 1"
            [canRemoveAddress]="
              getActualDeliveries().length > 1 && !isDecisionPointOrder
            "
            (customizationChanged)="onCustomizationChanged()"
            (changed)="onOrderItemChanged($event)"
            (refreshStatus)="refreshTrackingStatus()"
            [refreshingTrackingStatus]="refreshingTrackingStatus"
            (deliverToChanged)="onDeliveryChanged()"
          ></app-product-order-item-delivery>
        }
      }
    </div>
  }

  @if (!readonly && canOrder) {
    <!--  add another address-->
    @if (canAddAddress) {
      <div class="order-item__add-address">
        <a class="link link-underline" (click)="addAnotherAddress()">
          Add Another <i class="fas fa-plus"></i>
        </a>
      </div>
    }
    <!-- product variations-->
    @if (
      false && product.hasVariations && showVariations && !isDecisionPointOrder
    ) {
      <div class="order-item__variations">
        @for (sku of product.skus; track sku) {
          <div class="align-items-center order-item__variations--item">
            <div class="col-2 order-item__variations--input">
              <input
                min="0"
                digitOnly
                type="number"
                (change)="updateOrderItemVariation(sku)"
                [(ngModel)]="_orderItem.getVariationSKU(sku.id).quantity"
                [disabled]="!canAddQuantity"
              />
            </div>
            <div
              class="col-3 order-item__variations--description font-4 fw-bold"
            >
              <ul class="my-0">
                @for (label of getVariationLabel(sku); track $index) {
                  <li>{{ label }}</li>
                }
              </ul>
            </div>
            <div class="col-4 order-item__variations--price text-align-end">
              @if (!product.isBuyingWindow) {
                <app-product-order-item-in-stock
                  [product]="product"
                  [sku]="sku"
                  fontSize="font-5"
                  viewType="sku-item"
                  [orderItemId]="_orderItem.id"
                  class="mb-2"
                ></app-product-order-item-in-stock>
              }
              @if (showMinOrderInBody(sku)) {
                <app-product-order-item-min-max
                  [orderItem]="_orderItem"
                  [product]="product"
                  [showQuantityInSeparateLine]="true"
                  [headerPosition]="false"
                  [sku]="sku"
                  viewType="detailed"
                  fontSize="font-5"
                >
                </app-product-order-item-min-max>
              }
            </div>
            <div class="col-3 order-item__variations--price ms-2 ml-05rem">
              <app-product-order-item-price
                [orderItem]="_orderItem"
                [sku]="sku"
                fontSize="font-2"
              ></app-product-order-item-price>
            </div>
          </div>
        }
      </div>
    }
    <!--    <ng-container *ngIf="product.isCustomizable && product.hasVariations">-->
    <!--      <div class="mt-3 d-flex align-items-center">-->
    <!--        <button (click)="addVariationsCustomization()"-->
    <!--          [disabled]="!canCustomize"-->
    <!--          class="btn btn-outline-primary me-2 ms-3">-->
    <!--          Customize-->
    <!--        </button>-->
    <!--        <customization-info [customizations]="variationCustomizations"></customization-info>-->
    <!--        <i *ngIf="!canCustomize && _order.isDecisionPoint"-->
    <!--          class="fal fa-exclamation-triangle yellow"-->
    <!--          title="This product can be customized but Decision Point Order does not support it. Please use other order."></i>-->
    <!--      </div>-->
    <!--    </ng-container>-->
    <!--  total quantity and cost-->
    @if (showTotals) {
      <div class="order-item__total mt-3">
        <div class="col-3 order-item__total--quantity">
          <div>
            <label class="label">Total Qty</label>
            <p class="fw-bold">{{ _orderItem.quantity }}</p>
          </div>
        </div>
        <div class="col-6">
          <!--    budgets-->
          @if (showBudget && budgets && budgets.length > 0 && canSeeBudgets) {
            <label class="label text-start">Budget Available</label>
            <ng-select
              class="ng-select--budgets"
              [items]="budgets"
              placeholder="Choose a budget"
              [readonly]="budgets.length === 1"
              dropdownPosition="bottom"
              [searchable]="false"
              [clearable]="false"
              bindValue="id"
              (change)="changeBudget($event)"
              name="budget"
              [(ngModel)]="selectedBudgetId"
            >
              <ng-template ng-label-tmp let-item="item">
                @if (selectedBudget) {
                  <div class="font-5">
                    <div class="fw-bold text-start">
                      {{ selectedBudget.label }}
                    </div>
                    @if (selectedBudget.id > 0) {
                      <div class="text-start">
                        <span class="price d-inline fw-normal">
                          {{ selectedBudget.balance | currency }}
                        </span>
                        (Expires {{ selectedBudget.end_at | dateFormat }})
                      </div>
                    }
                  </div>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <div class="font-6">
                  <div class="fw-bold text-start">{{ item.label }}</div>
                  @if (item.id > 0) {
                    <div class="text-start">
                      <span class="price d-inline fw-normal">
                        {{ item.balance | currency }}
                      </span>
                      (Expires {{ item.end_at | dateFormat }})
                    </div>
                  }
                </div>
              </ng-template>
            </ng-select>
            @if (isBudgetExhausted) {
              <p
                class="font-5 color-red ng-star-inserted text-align-start mt-2"
              >
                {{ budgets[0].label }} is exhausted. Please alter existing order
                quantities to add more.
              </p>
            }
          }
        </div>
        <div class="col-3 order-item__total--cost">
          <div class="">
            <label class="label">Total Cost</label>
            <span class="font-1 fw-bold price">{{
              _orderItem.totalCost | currency
            }}</span>
            @if (!readonly) {
              <a
                class="link link-underline font-5 fw-normal btn-price-details"
                (click)="viewPriceDetails()"
                >View Details</a
              >
            }
          </div>
        </div>
      </div>
    }
    <!--    add to cart-->
    @if (!product.hasVariations || showVariations) {
      <div class="order-item__update">
        @if (product.window_id > 0 && product.in_stock) {
          <div class="order-item__update--buy-now mt-2">
            <div>
              <span>Need it sooner?</span>
              <a
                class="link underline"
                routerLink="/on-demand/products/{{ product.in_stock_slug }}"
                >Buy It Now</a
              >
            </div>
          </div>
        }
        <div class="order-item__update--cta">
          <div
            class="cta--container"
            [ngStyle]="{
              'align-items': showLeaseWarning ? 'flex-start' : 'center',
            }"
          >
            @if (showLeaseWarning) {
              <div class="me-2">
                <div class="text-center">
                  <p class="p-0 m-0">
                    A Lease Agreement is required to order this item.
                  </p>
                  <a
                    class="link small link-underline"
                    href="{{ leaseAgreementUrl }}"
                    target="_blank"
                    >Click here to Apply</a
                  >
                  <div class="text-center mt-3">
                    <p class="m-0 p-0">Already applied?</p>
                    <a
                      class="link small link-underline"
                      href="#"
                      (click)="checkLeaseStatus()"
                    >
                      Check your status
                      @if (checkingLease) {
                        <i class="fal fa-sync rotate ms-2"></i>
                      }
                    </a>
                    @if (leaseResult) {
                      @if (leaseResult !== product.attr_capex_type) {
                        <p class="m-0 p-0 red">
                          A Lease Agreement has not been approved for this
                          product.
                        </p>
                      }
                      @if (leaseResult === product.attr_capex_type) {
                        <p class="m-0 p-0 green">
                          A Lease Agreement has been approved for this product.
                        </p>
                      }
                    }
                  </div>
                </div>
              </div>
            }
            @if (purchaseResult.added) {
              <div class="purchase-result me-2">
                Your item was successfully added to your
                <a
                  class="link link-underline small"
                  (click)="redirectToShoppingCart()"
                  >shopping cart</a
                >
              </div>
            }
            @if (purchaseResult.updated) {
              <div class="purchase-result me-2">
                Your item was successfully updated in your
                <a
                  class="link link-underline small"
                  (click)="redirectToShoppingCart()"
                  >shopping cart</a
                >
              </div>
            }
            @if (purchaseResult.deleted) {
              <div class="purchase-result me-2">
                Your item has been removed from your
                <a
                  class="link link-underline small"
                  (click)="redirectToShoppingCart()"
                  >Shopping cart</a
                >
              </div>
            }
            @if (canOrder) {
              <button
                [attr.id]="'add-to-cart-btn-' + product.id"
                [disabled]="!canPurchase || orderItemUpdating"
                (click)="saveChanges()"
                type="button"
                class="btn btn-primary btn-purchase ms-auto me-3"
              >
                @if (orderItemUpdating) {
                  <i class="fal fa-sync rotate me-2"></i>
                }
                <span>{{ _orderItem.id ? 'Update' : 'Add To Cart' }}</span>
              </button>
            }
          </div>
          <div class="mt-3 pe-3">
            <app-favorite-toggle
              [product]="product"
              [isUpdating]="updatingFavorites"
              (toggleFavorite)="onToggleFavorites($event)"
              (close)="onClose()"
            ></app-favorite-toggle>
          </div>
        </div>
      </div>
    }
    @if (!discontinued && product.obsolete) {
      <ng-container *ngTemplateOutlet="productDiscontinued"> </ng-container>
    }
    @if (canShowProductPurchaseDetails) {
      <div class="mt-3 text-align-start">
        <app-product-orders-details
          [productId]="product.id"
          [modal]="modal"
          (showFull)="redirectToFullProduct()"
        ></app-product-orders-details>
      </div>
    }
  } @else {
    @if (canOrder) {
      <ng-container
        *ngTemplateOutlet="
          mobileDevice ? mobileTotalsContainer : desktopTotalsContainer
        "
      >
      </ng-container>
    }
  }

  @if (cancelled) {
    <div class="extra-opacity"></div>
  }
  @if (cancelled) {
    <div class="product-order-item--cancelled">Item has been canceled</div>
  }
</ng-template>

<ng-template #placeOrderMobileView>
  @if (
    !readonly &&
    isDecisionPointOrder &&
    !product.hasVariations &&
    (product.window_id > 0 ||
      !product.inventoryType ||
      product.inStock ||
      _orderItem.deliveries.length > 0)
  ) {
    <div class="order-item__decision-point bottom_line mt-3">
      @if (dpSummaryData) {
        <div class="d-flex flex-column align-items-center">
          <button
            (click)="showDpModal()"
            type="button"
            class="btn btn-outline-primary"
            [disabled]="!canShowDPModal"
          >
            <span>Update Decision Point Quantity</span>
          </button>
          <p class="text-center mt-2 color--primary-grey font-4">
            {{ dpSummaryData.eligible_wslr_count }} Wholesalers and
            {{ dpSummaryData.store_count }} Stores&nbsp;<button
              class="btn btn-icon"
              (click)="showDPFaqDialog()"
            >
              <i class="fas fa-exclamation-circle"></i>
            </button>
          </p>
        </div>
      }
      @if (loadingSummaryData) {
        <div>
          <app-infinite-progress [inProgress]="true"></app-infinite-progress>
        </div>
      }
    </div>
  }

  @if (!readonly && isDecisionPointOrder && product.hasVariations) {
    <div class="order-item__decision-point bottom_line">
      <p class="mt-3 color-red">
        Currently you cannot order by Decision Point for items with sizes or
        variations. Thank you for your patience.
      </p>
    </div>
  }

  @if (product.hasVariations && canOrder && !showVariations) {
    <div class="pb-3">
      <button
        class="btn btn-primary float-end"
        (click)="redirectToFullProduct()"
        type="button"
        name="update"
      >
        Product Detail
      </button>
      <p class="variation-message">
        This product has variations. Please use the product detail to order this
        item
      </p>
    </div>
  }

  <div>
    <!--    delivery items-->
    @if (delivery && _orderItem.hidden === false) {
      <app-product-order-item-delivery
        [delivery]="delivery"
        [product]="product"
        [viewType]="viewType"
        [order]="_order"
        [orderItem]="_orderItem"
        [readonly]="readonly"
        [showEditControls]="showEditControls"
        [totals]="totalCost"
        [showTotalInline]="!showTotals"
        [isFirstShipment]="true"
        [isLastShipment]="true"
        [showTrackingInfo]="showTrackingInfo"
        [canRemoveAddress]="!isDecisionPointOrder"
        [paidQuantity]="paidQuantity"
        (customizationChanged)="onCustomizationChanged()"
        (deliverToChanged)="onDeliveryChanged()"
        (changed)="onOrderItemChanged($event)"
        [refreshingTrackingStatus]="refreshingTrackingStatus"
        (refreshStatus)="refreshTrackingStatus()"
      ></app-product-order-item-delivery>
    }
    @if (!delivery && _orderItem.hidden === false) {
      @for (
        delivery of getActualDeliveries();
        track trackByDeliveryUuid(i, delivery);
        let i = $index
      ) {
        <app-product-order-item-delivery
          [delivery]="delivery"
          [product]="product"
          [viewType]="viewType"
          [order]="_order"
          [orderItem]="_orderItem"
          [readonly]="readonly"
          [showEditControls]="showEditControls"
          [totals]="totalCost"
          [showTotalInline]="!showTotals"
          [showTrackingInfo]="showTrackingInfo"
          [isFirstShipment]="i === 0"
          [isLastShipment]="getActualDeliveries().length == i + 1"
          [canRemoveAddress]="
            getActualDeliveries().length > 1 && !isDecisionPointOrder
          "
          (customizationChanged)="onCustomizationChanged()"
          (changed)="onOrderItemChanged($event)"
          (refreshStatus)="refreshTrackingStatus()"
          [refreshingTrackingStatus]="refreshingTrackingStatus"
          (deliverToChanged)="onDeliveryChanged()"
        ></app-product-order-item-delivery>
      }
    }
  </div>

  @if (!readonly && canOrder) {
    <!--  add another address-->
    @if (canAddAddress) {
      <div class="order-item__add-address">
        <a class="link link-underline" (click)="addAnotherAddress()">
          Add Another <i class="fas fa-plus"></i>
        </a>
      </div>
    }
    <!-- product variations-->
    @if (
      false && product.hasVariations && showVariations && !isDecisionPointOrder
    ) {
      <div class="order-item__variations full-width">
        @for (sku of product.skus; track sku) {
          <div class="mt-3 fw-bold">
            <ul class="sku--label my-0">
              @for (label of getVariationLabel(sku); track $index) {
                <li>{{ label }}</li>
              }
            </ul>
          </div>
          <div class="align-items-center order-item__variations--item">
            <div class="col-4 order-item__variations--input px-0 pe-3">
              <input
                min="0"
                digitOnly
                type="number"
                (change)="updateOrderItemVariation(sku)"
                [(ngModel)]="_orderItem.getVariationSKU(sku.id).quantity"
                [disabled]="!canAddQuantity"
              />
            </div>
            <div
              class="col-4 order-item__variations--price text-align-end px-0 pe-3"
            >
              @if (!product.isBuyingWindow) {
                <app-product-order-item-in-stock
                  [orderItemId]="_orderItem.id"
                  [product]="product"
                  [sku]="sku"
                  fontSize="font-5"
                  viewType="sku-item"
                  class="mb-2"
                ></app-product-order-item-in-stock>
              }
              @if (showMinOrderInBody(sku)) {
                <app-product-order-item-min-max
                  [orderItem]="_orderItem"
                  [product]="product"
                  [showQuantityInSeparateLine]="true"
                  [headerPosition]="false"
                  [sku]="sku"
                  viewType="detailed"
                  fontSize="font-5"
                ></app-product-order-item-min-max>
              }
            </div>
            <div class="col-4 order-item__variations--price px-0">
              <app-product-order-item-price
                [orderItem]="_orderItem"
                [sku]="sku"
                fontSize="font-2"
              ></app-product-order-item-price>
            </div>
          </div>
        }
      </div>
    }
    @if (product.isCustomizable && product.hasVariations) {
      <div class="mt-3 d-flex align-items-center">
        <button
          (click)="addVariationsCustomization()"
          [disabled]="!canCustomize"
          class="btn btn-outline-primary"
        >
          Customize
        </button>
        <customization-info
          [customizations]="variationCustomizations"
        ></customization-info>
        @if (!canCustomize && _order.isDecisionPoint) {
          <i
            class="fal fa-exclamation-triangle yellow"
            title="This product can be customized but Decision Point Order does not support it. Please use other order."
          ></i>
        }
      </div>
    }
    <!--  total quantity and cost-->
    @if (showTotals) {
      <div class="order-item__total mt-3">
        <div class="col-3 order-item__total--quantity px-0 pe-3">
          <div>
            <label class="label">Total Qty</label>
            <p class="fw-bold">{{ _orderItem.quantity }}</p>
          </div>
        </div>
        <div class="col-6 px-0 pe-3">
          <!--    budgets-->
          @if (showBudget && budgets && budgets.length > 0 && canSeeBudgets) {
            <label class="label text-start">Budget Available</label>
            <ng-select
              class="ng-select--budgets"
              [items]="budgets"
              placeholder="Choose a budget"
              [readonly]="budgets.length === 1"
              dropdownPosition="bottom"
              [searchable]="false"
              [clearable]="false"
              bindValue="id"
              (change)="changeBudget($event)"
              name="budget"
              [(ngModel)]="selectedBudgetId"
            >
              <ng-template ng-label-tmp let-item="item">
                @if (selectedBudget) {
                  <div class="font-5">
                    <div class="fw-bold text-start">
                      {{ selectedBudget.label }}
                    </div>
                    @if (selectedBudget.id > 0) {
                      <div class="text-start">
                        <span class="price d-inline fw-normal">{{
                          selectedBudget.balance | currency
                        }}</span>
                        (Expires {{ selectedBudget.end_at | dateFormat }})
                      </div>
                    }
                  </div>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <div class="font-6">
                  <div class="fw-bold text-start">{{ item.label }}</div>
                  @if (item.id > 0) {
                    <div class="text-start">
                      <span class="price d-inline fw-normal">{{
                        item.balance | currency
                      }}</span>
                      (Expires {{ item.end_at | dateFormat }})
                    </div>
                  }
                </div>
              </ng-template>
            </ng-select>
            @if (isBudgetExhausted) {
              <p
                class="font-5 color-red ng-star-inserted text-align-start mt-2"
              >
                {{ budgets[0].label }} is exhausted. Please alter existing order
                quantities to add more.
              </p>
            }
          }
        </div>
        <div class="col-3 order-item__total--cost px-0">
          <div>
            <label class="label">Total Cost</label>
            <span class="font-1 fw-bold price">{{
              _orderItem.totalCost | currency
            }}</span>
            @if (!readonly) {
              <a
                class="link link-underline font-5 fw-normal btn-price-details"
                (click)="viewPriceDetails()"
                >View Details</a
              >
            }
          </div>
        </div>
      </div>
    }
    <!--    add to cart-->
    @if (!product.hasVariations || showVariations) {
      <div class="order-item__update">
        @if (product.window_id > 0 && product.in_stock) {
          <div class="order-item__update--buy-now mt-2">
            <div>
              <span>Need it sooner?</span>
              <a
                class="link underline"
                routerLink="/on-demand/products/{{ product.in_stock_slug }}"
                >Buy It Now</a
              >
            </div>
          </div>
        }
        <div class="order-item__update--cta">
          @if (showLeaseWarning) {
            <div class="mt-3">
              <div class="text-center">
                <p class="p-0 m-0">
                  A Lease Agreement is required to order this item.
                </p>
                <a
                  class="link small link-underline"
                  href="{{ leaseAgreementUrl }}"
                  target="_blank"
                  >Click here to Apply</a
                >
                <div class="text-center mt-3">
                  <p class="m-0 p-0">Already applied?</p>
                  <a
                    class="link small link-underline"
                    href="#"
                    (click)="checkLeaseStatus()"
                    >Check your status
                    @if (checkingLease) {
                      <i class="fal fa-sync rotate ms-2"></i>
                    }
                  </a>
                  @if (leaseResult) {
                    @if (leaseResult !== product.attr_capex_type) {
                      <p class="m-0 p-0 red">
                        A Lease Agreement has not been approved for this
                        product.
                      </p>
                    }
                    @if (leaseResult === product.attr_capex_type) {
                      <p class="m-0 p-0 green">
                        A Lease Agreement has been approved for this product.
                      </p>
                    }
                  }
                </div>
              </div>
            </div>
          }
          <div class="cta--container">
            @if (purchaseResult.added) {
              <div class="purchase-result me-2">
                Your item was successfully added to your
                <a
                  class="link link-underline small"
                  (click)="redirectToShoppingCart()"
                  >shopping cart</a
                >
              </div>
            }
            @if (purchaseResult.updated) {
              <div class="purchase-result me-2">
                Your item was successfully updated in your
                <a
                  class="link link-underline small"
                  (click)="redirectToShoppingCart()"
                  >shopping cart</a
                >
              </div>
            }
            @if (purchaseResult.deleted) {
              <div class="purchase-result me-2">
                Your item has been removed from your
                <a
                  class="link link-underline small"
                  (click)="redirectToShoppingCart()"
                  >Shopping cart</a
                >
              </div>
            }
            @if (canOrder) {
              <button
                [disabled]="!canPurchase || orderItemUpdating"
                (click)="saveChanges()"
                type="button"
                class="btn btn-primary btn-purchase ms-auto me-0"
              >
                @if (orderItemUpdating) {
                  <i class="fal fa-sync rotate me-2"></i>
                }
                <span>{{ _orderItem.id ? 'Update' : 'Add To Cart' }}</span>
              </button>
            }
          </div>
          <div class="mt-3 pe-0">
            <app-favorite-toggle
              [product]="product"
              [isUpdating]="updatingFavorites"
              (toggleFavorite)="onToggleFavorites($event)"
              (close)="onClose()"
            ></app-favorite-toggle>
          </div>
        </div>
      </div>
    }
    @if (canShowProductPurchaseDetails) {
      <div class="mt-3 text-align-start">
        <app-product-orders-details
          [productId]="product.id"
        ></app-product-orders-details>
      </div>
    }
  } @else {
    @if (canOrder) {
      <ng-container
        *ngTemplateOutlet="
          mobileDevice ? mobileTotalsContainer : desktopTotalsContainer
        "
      >
      </ng-container>
    }
  }

  @if (cancelled) {
    <div class="extra-opacity"></div>
  }
  @if (cancelled) {
    <div class="product-order-item--cancelled">Item has been canceled</div>
  }
</ng-template>

<ng-template #desktopTotalsContainer>
  @if (_orderItem.hidden === false) {
    <div
      class="mt-3 ms-2"
      [ngStyle]="{ visibility: hideFinancials ? 'hidden' : 'initial' }"
    >
      <div class="totals fw-normal font-5">
        <div class="totals--cell">
          <div>
            <label class="text-align-center mb-2">total quantity</label>
            <span>{{ _orderItem.quantity }}</span>
          </div>
        </div>
        <div class="totals--cell">
          <div>
            <label class="mb-2">subtotal</label>
            <span class="price fw-normal">{{
              _orderItem.subTotal | currency
            }}</span>
          </div>
        </div>
        <div class="totals--cell">
          <div>
            <label class="mb-2">shipping</label>
            <span class="price fw-normal">{{
              _orderItem.shippingTotal | currency
            }}</span>
          </div>
        </div>
        <div class="totals--cell">
          <div [ngClass]="{ 'color-red': taxExemptOrderHasTaxes }">
            <label class="mb-2">
              taxes
              @if (taxExemptOrderHasTaxes) {
                <i
                  class="fas fa-info-circle"
                  placement="right"
                  tooltipClass="tooltips"
                  ngbTooltip="{{ taxExemptReason }}"
                ></i>
              }
            </label>
            <span class="price fw-normal">{{ taxes | currency }}</span>
          </div>
        </div>
        <div class="totals--cell">
          @if (_orderItem.totalDiscount > 0) {
            <div>
              <label class="mb-2">discount</label>
              <div class="green">
                <span>-&nbsp;</span>
                <span class="price d-inline-block fw-normal">{{
                  _orderItem.totalDiscount | currency
                }}</span>
              </div>
            </div>
          }
        </div>
        <div class="totals--cell">
          @if (_orderItem.budget > 0) {
            <div>
              <label class="mb-2">budget</label>
              <div class="green">
                <span>-&nbsp;</span
                ><span class="price d-inline-block fw-normal">{{
                  _orderItem.budget | currency
                }}</span>
              </div>
            </div>
          }
        </div>
        <div class="totals--cell">
          <div>
            <label class="fw-bold mb-2 text-center">total cost</label>
            <span
              [attr.id]="'item-total-cost-' + _orderItem.id"
              class="price"
              >{{ financialTotalCost | currency }}</span
            >
          </div>
        </div>
      </div>
    </div>
  }
  <div class="col col-lg-3 col-12 order-item--cost px-3">
    @if (canDisplayEditControls) {
      <div class="order-item--controls">
        @if (canEditOrder) {
          <button
            [attr.id]="'edit-item-btn-' + _orderItem.id"
            class="btn btn-outline-primary"
            (click)="handleEdit()"
            [disabled]="
              _orderItem.product.isCancelled ||
              _orderItem.product.active !== true
            "
          >
            Edit
          </button>
        }
        <a
          [attr.id]="'remove-item-btn-' + _orderItem.id"
          class="link link-underline small"
          (click)="onHandleRemove()"
          >Remove</a
        >
      </div>
    }
  </div>
</ng-template>

<ng-template #mobileTotalsContainer>
  @if (_orderItem.hidden === false) {
    <div
      class="mt-3"
      [ngStyle]="{ visibility: hideFinancials ? 'hidden' : 'initial' }"
    >
      <div class="totals fw-normal font-5">
        <div class="col-2 px-0 text-align-center">
          <label class="d-block text-align-center mb-2">QTY</label>
          <span class="fw-bold">{{ _orderItem.quantity }}</span>
        </div>
        <div class="col-4 offset-6 px-0 text-align-center">
          <label class="d-block mb-2 uppercase">total cost</label>
          <span class="price font-3">{{ financialTotalCost | currency }}</span>
        </div>
      </div>
    </div>
  }
  <div class="col col-lg-3 col-12 order-item--cost px-3">
    @if (canDisplayEditControls) {
      <div class="order-item--controls">
        @if (canEditOrder) {
          <button
            class="btn btn-outline-primary"
            (click)="handleEdit()"
            [disabled]="
              _orderItem.product.isCancelled ||
              _orderItem.product.active !== true
            "
          >
            Edit
          </button>
        }
        <a class="link link-underline small" (click)="onHandleRemove()"
          >Remove</a
        >
      </div>
    }
  </div>
</ng-template>

<ng-template #mobileReadOnlyView>
  @if (viewType === 'list-item') {
    <div class="product-order-item__row">
      <div>
        @if (product.media) {
          <div class="image">
            <img [src]="product.media | thumbnail" [alt]="product.label" />
          </div>
        }
        <div>
          @if (!product.hasVariations) {
            <app-product-order-item-price
              [orderItem]="_orderItem"
              [ngClass]="'list-item'"
              [modal]="modal"
              fontSize="font-3"
            ></app-product-order-item-price>
          }
        </div>
      </div>
      <div>
        <!--header-->
        <app-product-order-item-header
          [orderItem]="_orderItem"
          [order]="_order"
          [viewType]="viewType"
          [showHideItemButton]="showHideItemButton"
          [showReorderButton]="showReorderButton"
          [readonly]="readonly"
          [modal]="modal"
          (changedVisibility)="onOrderItemChangeVisibility($event)"
          (editted)="onUpdate.emit()"
          (reorderItem)="reorderItem()"
        ></app-product-order-item-header>
      </div>
    </div>
    <div>
      <ng-container
        *ngTemplateOutlet="mobileDevice ? placeOrderMobileView : placeOrderView"
      ></ng-container>
    </div>
  } @else {
    <div class="d-flex align-items-start justify-content-between">
      <div>
        @if (!product.hasVariations) {
          <app-product-order-item-price
            [orderItem]="_orderItem"
            [ngClass]="'list-item'"
            [modal]="modal"
            fontSize="font-2"
          >
          </app-product-order-item-price>
        }
      </div>
      <div>
        <!--header-->
        <app-product-order-item-header
          [orderItem]="_orderItem"
          [order]="_order"
          [viewType]="viewType"
          [showHideItemButton]="showHideItemButton"
          [showReorderButton]="showReorderButton"
          [readonly]="readonly"
          [modal]="modal"
          (changedVisibility)="onOrderItemChangeVisibility($event)"
          (editted)="onUpdate.emit()"
          (reorderItem)="reorderItem()"
        >
        </app-product-order-item-header>
      </div>
    </div>
    <div>
      <ng-container
        *ngTemplateOutlet="mobileDevice ? placeOrderMobileView : placeOrderView"
      ></ng-container>
    </div>
  }
</ng-template>

<ng-template #productDiscontinued>
  <p class="search--label font-5 color--primary-grey">
    Need to find a different item?
  </p>
  <div class="search--container">
    <app-search></app-search>
  </div>
</ng-template>
